export default () => {
    
	/*-------- Rejoindre anim --------*/
	if ($(".block-join-anim").length) {
		const $container = $('.block-join-anim');
		const $images = $container.find('.container-image');
		const $titles = $container.find('.title');
		let currentIndex = 0;
		const totalItems = $images.length;
		const duration = 2500;

		function showItem(index) {
			$images.removeClass('active').hide();
			$titles.removeClass('active');

			const $currentImage = $($images[index]);
			const $currentTitle = $($titles[index]);

			$currentImage.addClass('active').fadeIn(500);
			$currentTitle.addClass('active');

			$titles.find('.progress-fill').css('width', '0');
			$currentTitle.find('.progress-fill').css('width', '100%');
		}

		function nextItem() {
			currentIndex = (currentIndex + 1) % totalItems;
			showItem(currentIndex);
		}

		showItem(currentIndex);

		setInterval(nextItem, duration);
	}
    
}